  <!-- 应收应付审核总表 -->
  <template>
  <div>
    <!-- 按钮列表 -->
    <butotn-plug
      :btndata="BTN_CONFIG"
      @btnEvent="callBack"
      @clearBtns="clearBtns"
      @moreParam="moreParam"
      @queryBtn_ok="queryBtn_ok"
    />
    <!-- 查询列表 -->
    <input-plug
      ref="queryForm"
      :form-config="baseConfig"
      :form-data="queryData"
      :More="isHaseMore"
    >
      <template slot="time1">
        <multitime
          :timeType="timeType"
          :timeTypes="timeTypes"
          :startTime="startTime_a"
          :endTime="endTime_a"
          @timestatus="timestatus"
          @queryBtn_ok="queryBtn_time"
        >
        </multitime
      ></template>
    </input-plug>
    <!-- 表格 -->
    <table-plug
      :tableConfig="tableConfig"
      :defaulthead="myTableHeard"
      :totals="totalArr"
      @selectChange="handleSelectionChange"
      @rowCallback="rowCallback"
    />
    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
    </paging>
    <!--        自定义表头           -->
    <!-- 
        * 表头的方法提取到Mixin.js里面了
          show_sortTableHeard、allCheck、originalTabelHeadeTitle、selectLength
          confirmOk、checktab、checkAll、closeDias、cancelSortHeard
         -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    />
  </div>
</template>
   <script >
import { mixin_1 } from "@/assets/js/Mixins/mixin";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import ButotnPlug from "@/components/Modules/ButtonPlug.vue";
import InputPlug from "@/components/Modules/InputPlug.vue";
import multitime from "@/components/multiTime.vue";
import paging from "@/components/pagings.vue"; //分页组件
import TablePlug from "@/components/Modules/TablePlug.vue";
import MyDialog from "@/components/Dialog.vue";
import DiaForm from "@/pages/VMS/VMSConpon/DiaForm.vue";
import ImgUpload from "@/components/Modules/ImgUpload.vue";
import RecordTable from "@/pages/FinancialManagement/FinancialWriteOff/FMMOD/RecordTable.vue";
export default {
  mixins: [mixin_1],
  components: {
    ButotnPlug,
    InputPlug,
    multitime,
    TablePlug,
    paging,
    sorttable,
    MyDialog,
    DiaForm,
    ImgUpload,
    RecordTable,
  },
  data() {
    return {
      // 按钮配置
      BTN_CONFIG: [
        {
          name: "审核",
          method: {
            methodname: "Examine",
            title: "确认要审核通过所选数据？",
          },
        },
        {
          name: "返审核",
          method: {
            methodname: "UnExamine",
            title: "确认要返审核所选数据？",
          },
        },
        {
          name: "表格设置",
          method: "SetTable",
        },
        {
          name: "导出",
          method: "exportData",
        },
      ],
      // 更多搜索
      isHaseMore: false,
      //  查询框
      baseConfig: [
        {
          type: "timeSelect",
          slotName: "time1",
        },
        {
          type: "select",
          label: "审核状态",
          field: "id",
          placeholder: "请选择",
          selectOptions: [{ label: "全部", val: "1" }],
        },
        {
          type: "select",
          label: "结算对象",
          field: "id",
          placeholder: "请选择",
          selectOptions: [{ label: "全部", val: "1" }],
        },
        {
          type: "select",
          label: "业务网点",
          field: "id",
          placeholder: "请选择",
          selectOptions: [{ label: "全部", val: "1" }],
        },
        {
          type: "select",
          label: "单据类型",
          field: "id",
          placeholder: "请选择",
          selectOptions: [{ label: "全部", val: "1" }],
        },
        {
          type: "input",
          label: "来源单据",
          field: "id",
          placeholder: "请输入",
        },
      ],

      queryData: {
        id: "",
        name: "",
        phone: "",
        status: "",
      },
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "创建日期",
        },
      ],
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",
      // 表格配置
      tableConfig: {
        tableHeigth: "75vh",
        tableData: [],
      },
      myTableHeard: [],
      pageGroupName: "OtherIncome",
      tabelHeadeTitle: [
        {
          name: "其他收支单号",
          field: "a",
          width: "130", // default：120
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计 default：false
          isSort: true, //表格设置里面是否可以排序 default：false
        },
        {
          name: "收支方向",
          field: "b",
          sort: 4,
          isShow: true,
        },
        {
          name: "业务网点",
          field: "c",
          sort: 5,
          isShow: true,
        },
        {
          name: "发生日期",
          field: "billStorepackNumber",
          sort: 5,
          isShow: true,
        },
        {
          name: "结算对象类型",
          field: "billStorepackChannelNumber",
          width: "130",
          sort: 6,
          isShow: true,
        },
        {
          name: "结算对象",
          field: "frameName",
          sort: 1,
          isShow: true,
        },
        {
          name: "费项类型",
          field: "packageStatusShow",
          sort: 1,
          isShow: true,
        },
        {
          name: "费项",
          field: "storepackStatusShow",
          sort: 18,
          isShow: true,
        },
        {
          name: "发生金额",
          field: "isRejectionShow",
          sort: 19,
          isShow: true,
        },
        {
          name: "付款方式",
          field: "checkStatusShow",
          sort: 1,
          isShow: true,
        },
        {
          name: "总重量",
          field: "itemCategoryShow",
          sort: 1,
          isShow: true,
        },
        {
          name: "总体积",
          field: "intoStockTime",
          sort: 2,
          isShow: true,
        },
        {
          name: "来源单号",
          field: "storageName",
          sort: 2,
          isShow: true,
        },

        {
          name: "业务网点",
          field: "boxCount",
          sort: 1,
          isShow: true,
        },
        {
          name: "车牌号码",
          field: "packageWeight",
          sort: 1,
          isShow: true,
        },
        {
          name: "是否需要核销",
          field: "packageVolume",
          width: "160",
          sort: 1,
          isShow: true,
        },
        {
          name: "摘要",
          field: "packageComment",
          sort: 1,
          isShow: true,
        },
        {
          name: "票据类型",
          field: "billPackNumber",
          sort: 180,
          isShow: true,
        },

        {
          name: "票据号",
          field: "areaCountryName",
          sort: 6,
          isShow: true,
        },
        {
          name: "经办人",
          field: "postCode",
          sort: 1,
          isShow: true,
        },

        {
          name: "经办时间",
          field: "packageCreateTime",
          sort: 1,
          isShow: true,
        },
        {
          name: "过账状态",
          field: "packageCreateTime",
          sort: 1,
          isShow: true,
        },
        {
          name: "过账人",
          field: "packageCreateTime",
          sort: 1,
          isShow: true,
        },
        {
          name: "过账时间",
          field: "packageCreateTime",
          sort: 1,
          isShow: true,
        },
        {
          name: "创建时间",
          field: "packageCreateTime",
          sort: 1,
          isShow: true,
        },
        {
          name: "创建人",
          field: "packageCreateTime",
          sort: 1,
          isShow: true,
        },
      ],
      sortName: "其他收入", //  排序名
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
    //获取默认表头 页面有这四个字段 myTableHeard,sortName,tabelHeadeTitle,totalArr
    // this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
  },
  created() {},
  methods: {
    // 导出
    exportData() {
      this.$COMAPI.exportBtn({
        pageGroupName: this.pageGroupName, //页面标识
        myTableHeard: this.myTableHeard, //表头数组
        className: this.className, //列表标识
        tableData: this.tableConfig.tableData, //数据源
        sheetName: "表名(暂无效)", //表名
      });
    },
    // 审核
    Examine() {
      this.$message.success("ok");
    },
    // 返审核
    UnExamine() {
      this.$message.success("ok");
    },
    // 表格设置
    SetTable() {
      this.$TOOLS.myModel(this);
    },
    // 更多搜索
    moreParam(e) {
      this.isHaseMore = e;
      //动态调整表格大小
      // this.$nextTick(() => {
      //   this.fetTableHeight();
      // });
    },

    // 清空查询
    clearBtns() {
      console.log(2222);
    },
    // 查询事件
    queryBtn_ok() {
      console.log(this.queryData);
    },
    // 表格右侧按钮回调事件
    rowCallback(data, name) {
      this[name](data);
    },
    // 表格选择事件
    handleSelectionChange(e) {
      console.log("表格选择事件");
    },

    goYdDetails(a) {
      this.$message.success("你点我干嘛");
    },
  },
};
</script>
  <style scoped lang="less">
</style>
                    